<template>
    <div class="dashboard-card" :style="cardStyles">
        <slot />
    </div>
</template>

<script>

export default {
    name: 'DashboardCard',
    props: {
        borderColor: {
            type: String,
            default: '#dce2e8'
        },
        backgroundColor: {
            type: String,
            default: '#ffffff'
        }
    },
    computed: {
        cardStyles() {
            return {
                borderColor: this.borderColor,
                backgroundColor: this.backgroundColor
            }
        }
    }
}
</script>

<style scoped>
.dashboard-card {
    padding: 1rem;
    border-radius: calc(0.75rem + 4px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border: 1px solid var(--primary);
}
</style>
